import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Logo from "./logo";


function UpperNav() {
    return (
      <nav className="fixed top-0 left-0 right-0 z-40 flex items-center justify-between h-16 w-full px-4 bg-white shadow-sm sm:static sm:h-auto sm:mt-3 sm:ml-2 sm:mr-4">
    <div className="flex items-center h-full py-2 sm:py-0">
      <Logo />
    </div>
  </nav>


    );
  }

export default UpperNav;